var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAufdach(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.944,
    height: 64.316,
    viewBox: "0 0 75.944 64.316",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Komponente_12_2",
    "data-name": "Komponente 12 \\u2013 2",
    transform: "translate(0.695 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_35",
    "data-name": "Pfad 35",
    d: "M29.353,164.863l16.7-24.525,17.266,25.351",
    transform: "translate(-29.353 -132.439)",
    fill: "none",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_36",
    "data-name": "Pfad 36",
    d: "M35.158,140.338H70.367l17.6,25.35H52.762",
    transform: "translate(-18.455 -132.439)",
    fill: "none",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_37",
    "data-name": "Pfad 37",
    d: "M30.85,150.125v19l24.958,8.157V150.125",
    transform: "translate(-26.544 -114.064)",
    fill: "none",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_38",
    "data-name": "Pfad 38",
    d: "M39.524,175.93l35.643-8.157V150.845",
    transform: "translate(-10.26 -112.712)",
    fill: "none",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_7",
    "data-name": "Gruppe 7",
    transform: "translate(21.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_39",
    "data-name": "Pfad 39",
    d: "M54.582,162.943H89.788l-17.6-25.35H36.978Z",
    transform: "translate(-36.978 -137.593)",
    fill: "#fff",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_15",
    "data-name": "Linie 15",
    x2: 17.604,
    y2: 25.351,
    transform: "translate(9.174)",
    fill: "none",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_16",
    "data-name": "Linie 16",
    x2: 17.604,
    y2: 25.351,
    transform: "translate(17.604)",
    fill: "none",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_17",
    "data-name": "Linie 17",
    x2: 17.604,
    y2: 25.351,
    transform: "translate(26.034)",
    fill: "none",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_18",
    "data-name": "Linie 18",
    x2: 35.207,
    transform: "translate(9.174 12.676)",
    fill: "none",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_19",
    "data-name": "Linie 19",
    x2: 35.207,
    transform: "translate(4.39 6.267)",
    fill: "none",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_20",
    "data-name": "Linie 20",
    x2: 35.207,
    transform: "translate(13.321 18.943)",
    fill: "none",
    stroke: "#8ea1bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAufdach);
export default __webpack_public_path__ + "static/media/aufdach.9c10a8acf3aaeec3dde2c9b604a104d0.svg";
export { ForwardRef as ReactComponent };